export const DAY_DATE_FORMAT = "YYYY-MM-DD";

// we do not deal with seconds
export const DAY_DATETIME_FORMAT = "YYYY-MM-DD[T]HH:mm";

// we do not deal with seconds
export const DAY_TIME_FORMAT = "HH:mm";

export const VISUAL_DATE_FORMAT = "l"; // becomes M/D/YYYY for EN, DD.MM.YYYY for NB etc
export const VISUAL_DATETIME_FORMAT = "l LT";
export const VISUAL_TIME_FORMAT = "LT"; // becomes h:mm A for EN, HH:mm for NB etc
export const VISUAL_TIME_FORMAT_DAY = "ddd";

export const CLEAN_VISUAL_DATE_FORMAT = "DDMMYYYY";
